import React from 'react';
import './Footer.css';

// Importando os ícones do Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

function Footer() {
  
  const email = 'contato@helloworldstudio.com.br';

  return (
    <footer className="footer">
      <div className="footer-left">
        <p>© 2025 Hello World Games Studio. Todos os direitos reservados.</p>
      </div>
      <div className="footer-right">
        <div className="footer-links">
          <a href="href=mailto:contato@helloworldstudio.com.br" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faEnvelope} className="social-icon" /> E-mail
          </a>
          <a href="https://www.instagram.com/helloworldgamesstudio/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faInstagram} className="social-icon" /> Instagram
          </a>
          {/* <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faLinkedin} className="social-icon" /> LinkedIn
          </a> */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
